import axios from "axios";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import { AlertState, DetailNewsState, RouteConfigState } from "../../states";
import { API_ROUTES, PermissionMenuKey } from "../../utils/constants";
import { useQuery } from "hooks/useQuery";

function GetDetailNews() {
  const { id } = useQuery();
  const setAlert = useSetRecoilState(AlertState);

  const [newsState, setNewsState] = useRecoilState(DetailNewsState);
  const [route, setRoute] = useRecoilState(RouteConfigState);

  useEffect(() => {
    const getDetail = (id) => {
      axios
        .get(API_ROUTES.TINTUC + "/" + id)
        .then((response) => {
          const data = response.data;
          setNewsState(data);
          if (data && data.id) {
            const newRouteConfig = JSON.parse(JSON.stringify(route));
            if (
              newRouteConfig &&
              newRouteConfig.length > 0 &&
              newRouteConfig[2] &&
              newRouteConfig[2]?.collapse &&
              newRouteConfig[2]?.collapse.length > 0 &&
              newRouteConfig[2].collapse[0]
            ) {
              newRouteConfig[2].collapse[0].key = data?.slug
                ? data?.slug
                : "tintuc";
              newRouteConfig[2].collapse[0].name = data?.tieude
                ? data?.tieude
                : "Chi tiết tin tức";
              newRouteConfig[2].collapse[0].title = data?.tieude
                ? data?.tieude
                : "Chi tiết tin tức";
              newRouteConfig[2].collapse[0].route = `/${PermissionMenuKey.tinTuc}/${data?.slug}?id=${data?.id}`;
              setRoute(newRouteConfig);
            }
          }
        })
        .catch((error) => {
          setAlert({
            alert: true,
            message: error?.message || "Lỗi!",
            type: "error",
          });
        });
    };
    if (id && id != newsState?.id) {
      getDetail(id);
    }
  }, [id]);

  return <></>;
}

export default GetDetailNews;
